export default __webpack_public_path__ + "static/media/paint.084ff2c7.svg";